/* GLOWRY — editorial theme JS (vanilla) */
(function () {
  'use strict';

  var GL = window.GLOWRY || { currency: 'USD', routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' } };
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: GL.currency || 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { obs.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('visible'); }); }

  /* ---------- Header scroll state ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mega menus (hover) ---------- */
  var navItems = $$('.nav-item');
  function closeMega() {
    $$('.mega.open').forEach(function (m) { m.classList.remove('open'); });
    navItems.forEach(function (n) { n.classList.remove('open'); });
  }
  navItems.forEach(function (item) {
    var trigger = $('[data-mega-trigger]', item);
    if (!trigger) return;
    var id = trigger.getAttribute('data-mega-trigger');
    var panel = $('[data-mega-panel="' + id + '"]');
    item.addEventListener('mouseenter', function () {
      closeMega();
      if (panel) { panel.classList.add('open'); item.classList.add('open'); }
    });
  });
  if (header) header.addEventListener('mouseleave', closeMega);

  /* ---------- Mobile menu ---------- */
  var mobileMenu = $('[data-mobile-menu]');
  $$('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mobileMenu) return;
      var open = mobileMenu.classList.toggle('open');
      document.body.style.overflow = open ? 'hidden' : '';
      var t = $('[data-menu-toggle]');
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Search overlay ---------- */
  var searchOverlay = $('[data-search-overlay]');
  var scrim = $('[data-scrim]');
  function openSearch(on) {
    if (!searchOverlay) return;
    searchOverlay.classList.toggle('on', on);
    if (scrim) scrim.classList.toggle('on', on);
    if (on) { var i = $('input', searchOverlay); setTimeout(function () { if (i) i.focus(); }, 250); }
  }
  $$('[data-search-toggle]').forEach(function (b) { b.addEventListener('click', function () { openSearch(true); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { openSearch(false); }); });

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  function openDrawer(on) {
    if (!drawer) return;
    drawer.classList.toggle('on', on);
    if (scrim) scrim.classList.toggle('on', on);
  }
  $$('[data-cart-toggle]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(true); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); }); });
  if (scrim) scrim.addEventListener('click', function () { openDrawer(false); openSearch(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { openDrawer(false); openSearch(false); if (mobileMenu) { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; } }
  });

  function cleanName(t) { return (t || '').replace(/GLOWRY\s*/i, '').split('|')[0].trim(); }

  function renderCart(cart) {
    var body = $('[data-cart-body]');
    var count = $('[data-cart-count]');
    var subtotal = $('[data-cart-subtotal]');
    var checkout = $('[data-cart-checkout]');
    var badges = $$('[data-cart-badge]');

    if (count) count.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    badges.forEach(function (b) {
      b.textContent = cart.item_count;
      if (cart.item_count > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
    });
    if (checkout) {
      if (cart.item_count === 0) { checkout.style.opacity = '.4'; checkout.style.pointerEvents = 'none'; }
      else { checkout.style.opacity = ''; checkout.style.pointerEvents = ''; }
    }
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="empty"><span class="serif">Your bag is empty.</span><div class="mono" style="font-size:11px;letter-spacing:.12em;text-transform:uppercase">Add something to begin</div></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image || (it.featured_image && it.featured_image.url) || '';
      var opt = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="opt">' + it.variant_title + '</div>' : '';
      return '<div class="cart-line" data-line-key="' + it.key + '">' +
        '<div class="ci">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
        '<div><h5>' + cleanName(it.product_title) + '</h5>' + opt +
          '<div class="qty">' +
            '<button data-line-down="' + it.key + '" aria-label="Decrease"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button>' +
            '<span>' + it.quantity + '</span>' +
            '<button data-line-up="' + it.key + '" aria-label="Increase"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button>' +
            '<button class="rm" data-line-remove="' + it.key + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="price">' + money(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(variantId) {
    return fetch((GL.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function (item) {
      return refreshCart().then(function () {
        showToast('Added · ' + cleanName(item.product_title));
        openDrawer(true);
      });
    }).catch(function () { showToast('Could not add — try the product page'); });
  }

  function changeLine(key, qty) {
    return fetch((GL.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  /* delegated cart line controls */
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var up = e.target.closest('[data-line-up]');
      var down = e.target.closest('[data-line-down]');
      var rm = e.target.closest('[data-line-remove]');
      if (up || down || rm) {
        var line = e.target.closest('.cart-line');
        if (!line) return;
        var key = line.getAttribute('data-line-key');
        var qtyEl = $('.qty span', line);
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (rm) changeLine(key, 0);
        else if (up) changeLine(key, current + 1);
        else if (down) changeLine(key, Math.max(0, current - 1));
      }
    });
  }

  /* delegated add-to-bag from product cards */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      var id = add.getAttribute('data-add');
      if (id) addToCart(id);
    }
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WISH_KEY = 'glowry_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function setWish(arr) { try { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); } catch (e) {} }
  function updateWishBadge() {
    var n = getWish().length;
    $$('[data-wish-badge]').forEach(function (b) {
      b.textContent = n;
      if (n > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
    });
  }
  function markHearts() {
    var wish = getWish();
    $$('[data-wish]').forEach(function (h) {
      var on = wish.indexOf(h.getAttribute('data-wish')) !== -1;
      h.classList.toggle('on', on);
      var svg = $('svg', h);
      if (svg) svg.setAttribute('fill', on ? 'currentColor' : 'none');
    });
  }
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-wish]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      var handle = heart.getAttribute('data-wish');
      var wish = getWish();
      var idx = wish.indexOf(handle);
      if (idx === -1) { wish.push(handle); showToast('Saved to your list'); }
      else { wish.splice(idx, 1); }
      setWish(wish);
      markHearts();
      updateWishBadge();
    }
    var savedBtn = e.target.closest('[data-saved]');
    if (savedBtn) {
      var c = getWish().length;
      showToast(c === 0 ? 'No saved pieces yet' : c + ' piece' + (c !== 1 ? 's' : '') + ' saved');
    }
  });

  /* ---------- Homepage sort ---------- */
  var sortSel = $('[data-sort]');
  var grid = $('[data-product-grid]');
  if (sortSel && grid) {
    sortSel.addEventListener('change', function () {
      var items = $$('[data-sort-order]', grid);
      var mode = sortSel.value;
      items.sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-sort-price'), 10) || 0;
        var pb = parseInt(b.getAttribute('data-sort-price'), 10) || 0;
        var na = parseInt(a.getAttribute('data-sort-new'), 10) || 0;
        var nb = parseInt(b.getAttribute('data-sort-new'), 10) || 0;
        var oa = parseInt(a.getAttribute('data-sort-order'), 10) || 0;
        var ob = parseInt(b.getAttribute('data-sort-order'), 10) || 0;
        if (mode === 'low') return pa - pb;
        if (mode === 'high') return pb - pa;
        if (mode === 'new') return (nb - na) || (oa - ob);
        return oa - ob;
      });
      items.forEach(function (el) { grid.appendChild(el); });
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    var m = $('[data-toast-msg]', t);
    if (m) m.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 1800);
  }
  window.glowryToast = showToast;

  /* ---------- Init ---------- */
  markHearts();
  updateWishBadge();

  /* ============================================================
     PRODUCT PAGE — variant picker / qty / gallery (preserved)
     ============================================================ */
  var productForm = $('[data-product-form]');
  if (productForm) {
    var variantInput = $('[data-variant-id]', productForm);
    var priceEl = $('[data-product-price]');
    var compareEl = $('[data-product-compare]');
    var addBtn = $('[data-add-btn]', productForm);
    var optionInputs = $$('[data-option-input]', productForm);
    var variantsData = window.glowryVariants || [];

    function getSelectedOptions() {
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && input.checked) groups[input.name] = input.value;
        else if (input.tagName === 'SELECT') groups[input.name] = input.value;
      });
      return Object.keys(groups).map(function (k) { return groups[k]; });
    }
    function updateVariant() {
      var selected = getSelectedOptions();
      var matched = variantsData.find(function (v) { return v.options.every(function (opt, i) { return opt === selected[i]; }); });
      if (!matched) { if (variantInput) variantInput.value = ''; if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
      if (variantInput) variantInput.value = matched.id;
      if (priceEl) priceEl.textContent = matched.price_formatted;
      if (compareEl) {
        if (matched.compare_at_price && matched.compare_at_price > matched.price) { compareEl.textContent = matched.compare_at_price_formatted; compareEl.style.display = ''; }
        else compareEl.style.display = 'none';
      }
      if (addBtn) {
        if (matched.available) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.text || 'Add to Cart'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url);
    }
    optionInputs.forEach(function (input) { input.addEventListener('change', updateVariant); });

    var qtyInput = $('[data-qty]', productForm);
    var qtyMinus = $('[data-qty-minus]', productForm);
    var qtyPlus = $('[data-qty-plus]', productForm);
    if (qtyMinus && qtyInput) qtyMinus.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
    if (qtyPlus && qtyInput) qtyPlus.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });

    /* AJAX add-to-cart on the product page (keeps the drawer experience) */
    productForm.addEventListener('submit', function (e) {
      if (!variantInput || !variantInput.value) return; // let it post normally if no JS variant
      e.preventDefault();
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      fetch((GL.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (item) {
        return refreshCart().then(function () { showToast('Added · ' + cleanName(item.product_title)); openDrawer(true); });
      }).catch(function () { productForm.submit(); });
    });

    var thumbs = $$('[data-thumb]');
    var mainImg = $('[data-main-image]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (mainImg) mainImg.src = t.dataset.thumb;
      });
    });
  }
})();
